import React from 'react';
import styled, { css } from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import CoreImage from 'gatsby-theme-core/src/components/image';
import Content from 'gatsby-theme-core/src/components/content';
import Section from '../components/section';
import VariantButton from '../components/variant-button';

const TextImage = ({
  rowOptions,
  text,
  image,
  smallImage,
  template,
  className,
  columnLayout,
  smallImageSize = false,
  button,
}) => (
  <Section
    className={className}
    id={rowOptions?.sectionId || ''}
    backgroundColor={rowOptions?.backgroundColor}
    hideBottomSpacing={rowOptions?.hideBottomSpacing}
    hideTopSpacing={rowOptions?.hideTopSpacing}
    hideRow={rowOptions?.hideRow}
  >
    <Container small>
      <Wrapper columnLayout={columnLayout} template={template}>
        <ImageWrapper>
          {smallImageSize && smallImage && (
            <CoreImage
              image={smallImage}
            />
          )}
          {!smallImageSize && image && (
            <CoreImage
              image={image}
            />
          )}
        </ImageWrapper>
        <div>
          <StyledContent $content={text} />
          {button && (
            <StyledVariantButton
              variant={button.variant}
              to={button.link}
            >
              {button.text}
            </StyledVariantButton>
          )}
        </div>
      </Wrapper>
    </Container>
  </Section>
);

const ImageWrapper = styled.div`
  margin-left: -${({ theme }) => theme.grid.containerGap};
  margin-right: -${({ theme }) => theme.grid.containerGap};

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.sm}) {
    margin-left: 0;
    margin-right: 0;
  }

  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledVariantButton = styled(VariantButton)`
  margin-top: 1rem;
`;
const StyledContent = styled(Content)`
  h2 {
    color: ${({ theme }) => theme.secondaryColor};
    font-size: 1.5rem;
  }
  a {
    font-weight: 700;
  }
`;
const Wrapper = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-gap: 2rem;
  grid-template-columns: 1fr;
  align-items: center;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    grid-template-columns: 1fr 1fr;
    ${({ columnLayout }) => columnLayout === 'eight_four' && css`
      grid-template-columns: 8fr 4fr;
    `}
    ${({ columnLayout }) => columnLayout === 'four_eight' && css`
      grid-template-columns: 4fr 8fr;
    `}
  }
  ${({ template }) => template === 'image_text' && css`
    ${ImageWrapper} {
      @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
        order: 1;
      }
    }
  `}
`;

export default TextImage;
